import { validDocumentImageExtensions } from './imageTypes';

// lowercase only, keep this list of valid file types lowercase
const validFileTypes: string[] = [
  ...validDocumentImageExtensions,
  'csv',
  'doc',
  'md',
  'docx',
  'docm',
  'key',
  'numbers',
  'pages',
  'pdf',
  'ppt',
  'pptx',
  'pptm',
  'ppsm',
  'rtf',
  'txt',
  'xls',
  'xlsx',
  'xlsm',
  'xlsb',
  'zip',
];

export default validFileTypes;
